module.exports = __webpack_public_path__ + "img/img4.4a32e55d.png";